import React, { useState, useEffect } from 'react';
import { Table } from 'antd';
import { Base } from '../../public/js/base';
import './keyDocumentFileTypeModal.css'

const KeyDocumentFileTypeModal = (props) => {

    const [tables, setTables] = useState([]);

    useEffect(() => {
        searchKeyDocumentFileType();
    }, []);

    const searchKeyDocumentFileType = () => {
        let model = {
            "segment": 'KEY_DOCUMENT_FILE_TYPE',
        }
        Base.callBackApi("commonDropDown/searchSysParam", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setTables(data?.object ?? []);
            } else {
                console.log(data.msg);
            }
        }).catch(err => { });
    }

    const columns = [
        {
            title: 'Keyword',
            dataIndex: 'parmValue1',
            width: '15%',
        },
        {
            title: 'Description',
            dataIndex: 'parmValue2',
            width: '25%',
        },
        {
            title: 'Name of the Forms (as stipulated in the Framework)',
            dataIndex: 'parmValue3',
            width: '60%',
        },
    ];

    return (
        <div id="container" className='KeyDocumentFileTypeModal'>
            <div className="sysTable" id="tableKeyDocumentFileType" >
                <Table
                    rowKey="paramId"
                    columns={columns} //列名
                    dataSource={tables} //数据
                    pagination={false}
                />
            </div>
        </div>
    )

}

export default KeyDocumentFileTypeModal;